import { useMutation, useQuery } from "@tanstack/react-query";
import { volunteerEnrollmentApiService } from "./volunteerEnrollment.api.";

interface ApiResponse<T = any> {
  data: T;
  message: string;
  statusCode: number;
}

export const useVolunteerEnrollmentService = ({
  studyid,
  // otherid,
  searchText,
  pageNumber,
  pageSize,
  labelPrintStatus,
  idCardPrintStatus,
  filtersubjectstatus,
  getDropdown = false,
  volunteerassignmentid,
  enabled = true,
}: {
  studyid?: number | null;
  // otherid?: number | null;
  getDropdown?:boolean|null;
  searchText?: string | null;
  pageNumber?: number;
  pageSize?: number;
  labelPrintStatus?: string | null;
  idCardPrintStatus?: string | null;
  filtersubjectstatus?: boolean | null;
  volunteerassignmentid?: number | null;
  enabled?: boolean;
} = {}) => {

  // Dropdown
  const DropdownQuery = useQuery({
    queryKey: ["volunteer-enrollment-dropdown"],
    queryFn: () =>
      volunteerEnrollmentApiService.getDropdownData(
        studyid,
        searchText,
      ),
    enabled: !!studyid && !!getDropdown,
  });

  // SelectAll
  const SelectAllQuery = useQuery({
    queryKey: [
      "volunteer-enrollment-selectAll",
      studyid,
      searchText,
      pageNumber,
      pageSize,
      labelPrintStatus,
      idCardPrintStatus,
      filtersubjectstatus,
    ],
    queryFn: () =>
      volunteerEnrollmentApiService.getSelectAllData(
        studyid,
        searchText,
        pageNumber,
        pageSize,
        labelPrintStatus,
        idCardPrintStatus,
        filtersubjectstatus,
      ),
    enabled: enabled && !!studyid,               // prevent early call
  });

  // select printlog
  const SelectLogQuery = useQuery({
    queryKey: [
      "volunteer-enrollment-selectlog",
      volunteerassignmentid,
      searchText,
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      volunteerEnrollmentApiService.getSelectLogData(
        volunteerassignmentid,
        searchText,
        pageNumber,
        pageSize,
    
      ),
    enabled: !!volunteerassignmentid, // only fetch when valid id
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  // Insert
  const InsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerEnrollmentApiService.insertData(payload),
  });

  const LogInsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerEnrollmentApiService.loginsert(payload),
  });

  const LogBulkInsertMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerEnrollmentApiService.logbulkinsert(payload),
  });

  const UpdateMutation = useMutation<ApiResponse, Error, any>({
    mutationFn: (payload: any) =>
      volunteerEnrollmentApiService.updateData(payload),
  });

  // Delete
  const DeleteMutation = useMutation<
    ApiResponse,
    Error,
    { volunteerid: number | null; updatereason: string }
  >({
    mutationFn: (payload) =>
      volunteerEnrollmentApiService.deleteData(payload),
  });

  return {
    DropdownQuery,
    SelectAllQuery,
    SelectLogQuery,
    InsertMutation,
    UpdateMutation,
    DeleteMutation,
    LogInsertMutation,
    LogBulkInsertMutation,
  };
};
